import {PlayerColor} from "@game/coregame/settings";
import {ComponentClassName} from "@dp-instant/ui";
import {useRef} from "preact/hooks";
import cn from "classnames";

export type TexuredShopItemProps = {
    textureUrl?: string;
    playerColor?: PlayerColor | undefined;
    useImage?: boolean;
    className?: string;
} & ComponentClassName;

export const TexturedShopItem = ({
    textureUrl = "",
    playerColor = undefined,
    useImage = true,
    className = ""
}: TexuredShopItemProps) => {
    const svgWrapper = useRef<HTMLObjectElement>(null);

    const onItemPreload = () => {
        if (svgWrapper.current) {
            const svgDocument = svgWrapper.current.contentDocument;
            if (svgDocument) {
                const svg = svgDocument.getElementsByTagName("svg")[0];

                if (svg) {
                    let fill: string = "#000000";
                    if (playerColor) {
                        fill = playerColor[0];
                    }
                    svg.setAttribute("style", `fill:${fill}`);
                }
            }
        }
    };

    return (
        <>
            {useImage ? (
                <img
                    className={cn("shop-item-media-object", className)}
                    src={`assets/${textureUrl}`}
                />
            ) : (
                <object
                    ref={svgWrapper}
                    onLoad={onItemPreload}
                    type="image/svg+xml"
                    className={cn("shop-item-media-object")}
                    data={`assets/${textureUrl}`}
                ></object>
            )}
        </>
    );
};
